export const faqsArray = [
  {
    question:
      'Do you offer custom clips? What are the details including price?',
    answer: `Yes, I do offer custom clips. I always have submissions open unless clearly stated otherwise on this site.<br /><br />
    <strong>Pricing:</strong><br />
    $15/minute (5 minute minimum).<br /><br />
    Please message Me directly on LoyalFans or email Me at <a href="mailto:servequeenblaire2626@gmail.com" class="text-colour1 underline">servequeenblaire2626@gmail.com</a> with a description of the custom you’re looking for. I will agree to it, tweak it to fit what I enjoy making, or deny it.<br /><br />
    <strong>Turnaround time:</strong><br />
    Expect delivery within 4 weeks.<br /><br />
    <strong>Rush fees:</strong><br />
    3 weeks – $200 extra<br />
    2 weeks – $500 extra<br />
    1 week – $1000 extra<br /><br />
    <strong>Add-ons:</strong><br />
    Name inclusion – $500 extra<br />
    Outfit request – $75 extra<br />
    Custom pictures – $5 each<br />
    Custom audios – $8/min<br />
    Less than 5 minute custom videos – $12/min`,
  },
  {
    question: 'Do you offer in person sessions?',
    answer: `Yes. I am located on the West Coast of the United States.<br /><br />
    I prefer to meet subs in public over dinner before scheduling a session. I do not have set prices for in-person sessions at this time — pricing depends on what you are looking to experience.<br /><br />
    The kinks and fetishes I offer can be found in the Sessions tab.<br /><br />
    I have very high expectations for those wanting to meet Me in person. Please email Me directly at <a href="mailto:servequeenblaire2626@gmail.com" class="text-colour1 underline">servequeenblaire2626@gmail.com</a> with any additional questions.`,
  },
  {
    question: 'Do you offer virtual one-on-one sessions?',
    answer: `Yes. I offer photo, video, and audio response sessions on LoyalFans. Please message Me there for more information.<br /><br />
    <a href="https://www.loyalfans.com/queenb2626" target="_blank" rel="noopener noreferrer" class="text-colour1 underline">LoyalFans – QueenB2626</a><br /><br />
    I also offer one-on-one video calls via Discord or Telegram for $10 per minute.<br /><br />
    Please message Me beforehand about the type of session you’re looking for and availability. Payment is required <strong>before</strong> the call and must be made via CashApp or LoyalFans.`,
  },
  {
    question: 'Can I be your sub, Goddess?',
    answer: `This is a boring question. My true subs never asked it.<br /><br />
    They learned how to become one through communication, practice, and self-awareness. They <strong>earned</strong> it.<br /><br />
    A healthy dynamic does not form in hours, days, months, or even years. It requires time, patience, money, effort, and dedication to Me.<br /><br />
    If you believe you have what it takes, begin with a $100 tribute via CashApp, LoyalFans, or Throne, along with a long message explaining why you think you deserve to be at My feet.<br /><br />
    Only time will tell if you actually do.`,
  },
  {
    question: 'What do you look for in a sub, Goddess?',
    answer: `Qualities I value in a sub include:<br /><br />
    - Respectful and kind<br />
    - Financially stable (ideally earning $80k+ per year)<br />
    - Communicates clearly and asks questions<br />
    - Understands their place beneath Me<br />
    - Enjoys the outdoors<br />
    - Takes care of their body (fit and strong)<br />
    - Shares compatible kinks and fetishes<br />
    - Hard-working and dedicated<br />
    - Honest and organized<br />
    - Skilled at cooking and household tasks<br />
    - Strong sense of personal style<br />
    - Physically well-endowed (6 inches minimum)`,
  },
  {
    question: 'Do you remember me from years ago?',
    answer: `Unless you spent more than $60,000 on Me within a single year — no.<br /><br />
    If you want to be remembered this time, you’ll need to do something far more memorable.`,
  },
  {
    question: 'When are you online, Goddess?',
    answer: `I’m online Tuesday-Friday, I offer one on one sessions on any of those days. All you need to do is send $50 and message Me when you’re available and ready for a session or in advance to schedule one. I will respond when I can. <br />
I go live on Loyalfans and Chaturbate when I have the energy so keep an eye out for announcements regarding that.`,
  },
];
